"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflowFileUploader = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
// common File uploader for Workflow plugin configuration with InputHtml
// save to 'attachments' folder
function useWorkflowFileUploader(folderPath = 'attachments', setOnUpdate = false) {
    // wrap in useRef to avoid re-rendering
    const proxyOptions = (0, react_1.useRef)({
        key: 'key',
        path: 'forms/file'
    }).current;
    const [uploader, setUploader] = (0, react_1.useState)(() => {
        return (0, core_ui_1.createFileUploader)({
            // update state to re-render components when `uploader.items` get updated
            onUpdate: () => {
                setOnUpdate && setUploader(uploader => (Object.assign({}, uploader)));
            },
            getPresignedUrl: mimeType => {
                const request = core_ui_1.api.post(`forms/presign/${folderPath}`, { mimeType });
                const getResult = () => __awaiter(this, void 0, void 0, function* () {
                    const result = yield (0, core_ui_1.apiResolve)(request);
                    const { data, error } = result;
                    return {
                        error,
                        data: data && {
                            storageKey: new URL(data.destinationUrl).searchParams.get('key') || '',
                            signedUrl: data.signedUrl,
                            expiration: data.expiration
                        }
                    };
                });
                return { request, result: getResult() };
            }
        });
    });
    return { uploader, proxyOptions };
}
exports.useWorkflowFileUploader = useWorkflowFileUploader;
//# sourceMappingURL=useWorkflowFileUploader.js.map